import { defineComponent as _defineComponent } from 'vue'
import {useUserStore} from "@/store/user.store";
import {ConnectionType} from "@/api/wallet.connecton.api";
import {computed} from "vue";
import {useToast} from "vue-toastification";
import dataService from '@/services/data.service';
import {useConfigurationStore} from '@/store/configuration.store';
import {changeTitle} from "@/utils/title-changer";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutConfirm',
  props: {
  logoutType:{
    type: Number,
    required: true,
  }
},
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const logo = computed(() => {
  switch(props.logoutType){
    case ConnectionType.Keplr: return require('@/assets/keplrIcon2.png');
    case ConnectionType.Address: return '/globe.svg';
    case ConnectionType.Cosmostation: return require('@/assets/cosmostationIcon.png');
    case ConnectionType.Leap: return require('@/assets/leapIcon.png');
    default : return 'Logout';
  }
});

// const showKeplrLogo = computed(() => {
//   if(props.logoutType == ConnectionType.Keplr) {
//     return true;
//   } else {
//     return false;
//   }
// });

const emit = __emit;

const onChange = (event: any) => {
  useConfigurationStore().setNetwork(event.target.value);
  changeTitle();
  emit('close');
};

const configMap = computed(() => {return useConfigurationStore().getConfigList;});
const curentNetwork = computed(() => {
  return useConfigurationStore().getConfigName;
});

function logout(){
  dataService.onLogOutWallet();
  // useUserStore().logOut()
  emit('close');
}

function copyTxt(){
  navigator.clipboard.writeText(useUserStore().getAccount.address);
  useToast().success(i18n.global.t('COPY.ADDRESS'));
}

const addDotsInsideTooLongString = (text: string, maxLength: number): string => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength - 3) + "..." + text.substring(text.length - 2);
  }
  return text;
};


const __returned__ = { props, logo, emit, onChange, configMap, curentNetwork, logout, copyTxt, addDotsInsideTooLongString, get useUserStore() { return useUserStore }, get useConfigurationStore() { return useConfigurationStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})